export default {
  label: {
    id: 'input_address_nationality_label',
    defaultMessage: 'Nationality',
  },
  required: {
    id: 'input_address_nationality_required',
    defaultMessage: 'The nationality field is required',
  },
}
